import styled, { css } from 'styled-components'
import { TypographyComponent } from '../Typography'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import DownloadIcon from '@mui/icons-material/Download'

export const Container = styled('div')(
  ({ theme }) => css`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    padding: ${theme.layout.padding.small} ${theme.layout.padding.medium};
    background: ${theme.colors.base.lightGray};
    border-radius: ${theme.layout.borderRadius.small};
  `
)

export const Text = styled(TypographyComponent)(
  ({ theme }) => css`
    && {
      font-style: normal;
      font-weight: 500;
      font-size: ${theme.typograph.fontsize.h3};
      line-height: ${theme.layout.lineHeight.base * 4}rem;
      color: ${theme.colors.base.gray300};
      letter-spacing: 0.1rem;
    }
  `
)

export const StyledDeleteIcon = styled(DeleteOutlineIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      color: ${theme.colors.error.main};
      background: ${theme.colors.error.light};
      border-radius: 0.3rem;
      width: 3rem;
      height: 3rem;

      cursor: pointer;
    }
  `
)

export const StyledDownloadIcon = styled(DownloadIcon)(
  ({ theme }) => css`
    && {
      font-size: ${theme.typograph.fontsize.h8};
      color: ${theme.colors.primary.main};
      background: ${theme.colors.base.lightBrandBlue};
      border-radius: 0.3rem;
      width: 3rem;
      height: 3rem;

      cursor: pointer;
    }
  `
)
